import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { BaseDialogActionData } from '../base-dialog/base-dialog.model';
import { getSimpleDialogData } from './simple-dialog.data';
import { SimpleDialogData } from './simple-dialog.model';

@Component({
    selector: 'ifc-simple-dialog',
    templateUrl: './simple-dialog.component.html',
    styleUrls: ['./simple-dialog.component.scss'],
    standalone: false
})
export class SimpleDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SimpleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleDialogData
  ) { }

  static show(dialog: MatDialog, inputData: SimpleDialogData): Observable<string> {
    const data = getSimpleDialogData(inputData);

    return dialog
      .open(SimpleDialogComponent, {
        data: { ...data },
        closeOnNavigation: data.config.closeOnNavigation,
        width: data.config.width,
        autoFocus: data.config.autoFocus,
      })
      .afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    this.dialogRef.close(actionData.actionKey);
  }
}
